<template>
  <div class="share fixed l0 t0 r0 b0" v-if="showTag">
    <img :src="pic" alt="" @click="hide">
  </div>
</template>

<script>
  export default {
    name: 'v-share',
    data () {
      return {
        showTag: false,
        pic: ''
      }
    },
    created () {
      if (this.$device === 'iphone') {
        this.pic = require('../../assets/img/ios_guide.png')
      } else if (this.$device === 'android') this.pic = require('../../assets/img/android_guide.png')
    },
    methods: {
      show () {
        this.showTag = true
      },
      hide () {
        this.showTag = false
      }
    },
  }
</script>

<style lang="scss" scoped>
.share {
  z-index: 100000;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/v-share.vue